// components/ProjectDetails.jsx - 项目详情面板
import React, { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export function ProjectDetails({ project, onClose }) {
  console.log("Rendering project details for:", project); // 添加调试日志
  
  // 提取标签 - 既处理 technologies 数组，也处理 tags 数组，确保兼容性
  const projectTags = useMemo(() => {
    if (!project) return [];
    
    let tags = [];
    if (project.technologies && Array.isArray(project.technologies)) {
      tags = [...project.technologies];
    }
    if (project.tags && Array.isArray(project.tags)) {
      // 确保不重复添加标签
      project.tags.forEach(tag => {
        if (!tags.includes(tag)) {
          tags.push(tag);
        }
      });
    }
    return tags;
  }, [project]);
  
  // 处理内容中的标签行
  const processedContent = useMemo(() => {
    if (!project || !project.content) return '';
    // 移除标签行
    return project.content.replace(/^(#[\w\u4e00-\u9fa5_-]+\s*)+$/gm, '');
  }, [project]);
  
  if (!project) return null;

  return (
    <div className="experience-details project-overlay-custom"> {/* 复用 experience-details 样式，可加特定类调整 */}
      <div className="details-header" style={{ backgroundColor: (project.color || '#f39c12') + '22', borderColor: project.color || '#f39c12' }}>
        <h2>{project.name}</h2>
        <button className="close-button" onClick={onClose}>×</button>
      </div>
      
      <div className="details-content">
        <div className="details-summary">
          {project.company && <p className="location">关联公司: {project.company}</p>}
        </div>
        
        <div className="details-description">
          {project.content ? (
            <ReactMarkdown 
              remarkPlugins={[remarkGfm]}
              components={{
                // 改进图片渲染逻辑，避免使用固定行号判断
                img: ({node, ...props}) => {
                  // 解析图片URL，修复路径问题
                  let imgSrc = props.src;
                  if (imgSrc && imgSrc.startsWith('/public/')) {
                    // 移除/public/前缀，因为在浏览器中访问时不需要这个前缀
                    imgSrc = imgSrc.substring(7);
                  }
                  
                  return <img src={imgSrc} alt={props.alt || '项目图片'} style={{maxWidth: '100%'}} />
                },
                // 跳过一级标题，因为它已经被用作项目名称
                h1: () => null,
                // 过滤包含标签的段落
                p: ({node, ...props}) => {
                  // 检查该段落是否只包含标签
                  const content = props.children?.toString() || '';
                  if (content.trim().startsWith('#') && content.includes('#')) {
                    // 如果是标签行，则不显示
                    return null;
                  }
                  return <p {...props} />
                }
              }}
            >
              {processedContent}
            </ReactMarkdown>
          ) : (
            <>
              <h4>项目描述</h4>
              <p>{project.description}</p>
              
              {project.responsibilities && project.responsibilities.length > 0 && (
                <>
                  <h4>我的职责</h4>
                  <ul>
                    {project.responsibilities.map((resp, index) => (
                      <li key={index}>{resp}</li>
                    ))}
                  </ul>
                </>
              )}
            </>
          )}
          
          {/* 标签显示区域 */}
          {projectTags.length > 0 && (
            <div className="project-tags-section">
              <div className="skills-container">
                {projectTags.map((tech, index) => (
                  <span key={index} className="skill-tag">{tech}</span>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}